module.exports = __webpack_public_path__ + "img/about_knight_topright.2ba3c69f.png";